var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_377_16424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 6.66622L9.33319 3.99955M1.6665 14.3329L3.92275 14.0822C4.19841 14.0516 4.33624 14.0362 4.46507 13.9945C4.57936 13.9575 4.68814 13.9053 4.78843 13.8391C4.90147 13.7646 4.99953 13.6665 5.19565 13.4704L13.9999 4.66622C14.7362 3.92984 14.7362 2.73593 13.9999 1.99955C13.2635 1.26317 12.0696 1.26317 11.3332 1.99955L2.52899 10.8037C2.33287 10.9999 2.23481 11.0979 2.16026 11.211C2.09413 11.3113 2.04185 11.42 2.00485 11.5343C1.96314 11.6632 1.94783 11.801 1.9172 12.0766L1.6665 14.3329Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_16424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e4c5b5557b9d6437672706cf8732225c.svg";
export { ForwardRef as ReactComponent };